import type { ConfirmationsTranslations } from "../interfaces/confirmations";

export const confirmationsTranslations: ConfirmationsTranslations = {
  page_title: "Payment Confirmations",
  button_new_confirmation: "New Confirmation",
  toast_error_load: "Error loading confirmations",
  toast_error_load_more: "Error loading more confirmations",
  toast_success_create: "Confirmation created successfully",
  toast_error_create: "Error creating confirmation",
  toast_success_cancel: "Confirmation cancelled successfully",
  toast_error_cancel: "Error cancelling confirmation",
  toast_success_confirm: "Confirmation completed successfully",
  toast_warning_attachment: "Confirmation completed, but evidence could not be uploaded.",
  toast_error_confirm: "Error confirming transaction",
  toast_success_notify: "Client notified successfully",
  toast_error_notify: "Error notifying client",
  toast_success_taker_reminder: "Reminder sent successfully",
  toast_error_taker_reminder: "Error sending reminder",
  toast_no_image: "No image to open in new tab",
  loading: "Loading…",
  show_more: "Show more",
  alt_comprobante_pago: "Payment receipt",
  alt_comprobante_confirmacion: "Confirmation receipt",

  card_status_pending: "Pending",
  card_status_confirmed: "Confirmed",
  card_label_note: "Note:",
  card_label_created_by: "Created by:",
  card_label_updated_by: "Updated by:",
  card_label_created_at: "Created:",
  card_label_updated_at: "Last updated:",
  card_button_notify_client: "Client notified",
  card_button_taker_reminder: "Send a nudge",
  card_button_cancel: "Cancel",
  card_button_confirm: "Confirm",
  card_button_view_history: "View history",
  card_verified: "Verified",
  card_button_view: "View",
  card_button_open: "Open",
  card_loading: "Loading…",
  card_error_load: "Error loading",
  card_alt_comprobante: "Receipt",
  card_alt_comprobante_n: "Receipt {{n}}",

  board_empty_title: "No payment confirmations",
  board_empty_description:
    "Confirmations you create or receive will appear here. Use the «New confirmation» button to register a payment receipt.",
  column_pending: "Pending",
  column_confirmed: "Confirmed",
  column_empty_pending: "No pending confirmations. New confirmations will appear here.",
  column_refresh: "Refresh",
  column_refresh_aria: "Refresh confirmations",
  column_drag_to_confirm: "Drag to confirm",

  modal_cancel_title: "Cancel payment confirmation",
  modal_cancel_description:
    "Please tell us why you want to cancel this transaction. This action cannot be undone once confirmed.",
  modal_cancel_label_reason: "Cancellation reason",
  modal_cancel_placeholder: "Write the reason for cancellation here...",
  modal_cancel_back: "Back",
  modal_cancel_confirm: "Confirm cancellation",
  modal_cancel_confirming: "Cancelling...",
  modal_cancel_required: "The cancellation reason is required.",
  modal_cancel_close_aria: "Close",

  modal_new_title: "New payment confirmation",
  modal_new_submit: "Create request",
  modal_new_cancel: "Cancel",

  modal_confirm_title: "Confirm transaction",
  modal_confirm_description:
    "Are you sure you want to confirm this transaction? This action will be recorded in the history.",
  modal_confirm_source_label: "Bank income",
  modal_confirm_source_placeholder: "Select bank income",
  modal_confirm_source_required: "Bank income is required.",
  modal_confirm_attach_evidence: "Attach evidence",
  modal_confirm_no_attachments: "Do not send attachments",
  modal_confirm_evidence_label: "Evidence (images)",
  modal_confirm_evidence_description: "PNG, JPG, WebP up to 10 MB. You can select multiple files.",
  modal_confirm_evidence_instruction: "Click to select or drag files here",
  modal_confirm_back: "Back",
  modal_confirm_confirm: "Confirm",
  modal_confirm_evidence_required: "You must attach at least one receipt.",
  modal_confirm_close_aria: "Close",

  modal_client_notified_title: "Client notified",
  modal_client_notified_description:
    "The client was notified about this payment confirmation. The notification is recorded in the history.",
  modal_client_notified_close: "Close",
  modal_client_notified_confirm: "Confirm",
  modal_client_notified_close_aria: "Close",

  modal_history_title: "Payment confirmation details",
  modal_history_loading: "Loading history…",
  modal_history_error: "Could not load history.",
  modal_history_empty: "No records in history.",
  modal_history_section_title: "Change history",
  modal_history_initial_status: "Initial status",
  modal_history_previous_status: "Previous status",
  modal_history_current_status: "Current status",
  modal_history_duration: "Duration",
  modal_history_close: "Close",
  modal_history_close_aria: "Close",
  status_pending: "Pending",
  status_confirmed: "Confirmed",
  status_cancelled: "Cancelled",
  status_archived: "Archived",
  status_notified: "Notified",
  change_type_created: "Creation",
  change_type_status: "Status change",
  change_type_data: "Data update",
  change_type_attachment: "Attachment added",
  change_type_note: "Note added",

  form_label_client: "Client",
  form_placeholder_client: "Enter client name",
  form_checkbox_same_client: "Beneficiary is the same client",
  form_label_beneficiary: "Beneficiary",
  form_placeholder_beneficiary: "Beneficiary",
  form_label_amount: "Amount",
  form_label_currency: "Currency type",
  form_placeholder_currency: "Select currency...",
  form_label_bank: "Bank",
  form_placeholder_bank: "Select payment method...",
  form_placeholder_bank_currency_first: "Select a currency first",
  form_label_date: "Date",
  form_label_note: "Note",
  form_placeholder_note: "Add a note to this confirmation...",
  form_label_comprobante: "Receipt (image)",
  form_comprobante_description: "PNG, JPG, WebP up to 10 MB",
  form_comprobante_instruction: "Click to upload or drag here",
  form_comprobante_instruction_drop: "Drop the file here",
  form_comprobante_size_format: "Max {{max}} MB • Images (JPG, PNG, WebP)",
  form_comprobante_preview_alt: "Receipt preview",
  form_comprobante_change: "Change",
  form_comprobante_remove: "Remove",

  validation_cliente_required: "Client name is required.",
  validation_pagador_required: "Payer name is required.",
  validation_monto_invalid: "Enter a valid amount greater than zero.",
  validation_banco_required: "Bank is required.",
  validation_moneda_required: "Currency type is required.",
  validation_fecha_required: "Date is required.",
  validation_comprobante_required: "Receipt is required.",
};
